import { Command } from 'commands/Commands';

export class ChangeBusinessType extends Command {
  priority: 100;
  type: string = 'ChangeBusinessType';
}
